import { transactionStatusFetchedInstance } from '../../modules/TransactionStatus/TransactionStatus.utilities'

export default Object.assign({}, transactionStatusFetchedInstance())
